import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/divider/divider.component.js'

const tagName = 'dap-ds-divider'

/**
 * `dap-ds-divider`
 * @summary A divider is a visual separator between elements.
 * @element dap-ds-divider
 * @title - Divider
 *
 * @cssproperty --dds-divider-border-width - The width of the divider border. (default: var(--dds-border-width-base))
 * @cssproperty --dds-divider-border-style - The style of the divider border. (default: solid)
 * @cssproperty --dds-divider-border-color - The color of the divider border. (default: var(--dds-border-neutral-divider))
 * @cssproperty --dds-divider-border-color-inverted - The color of the divider border when inverted. (default: var(--dds-border-neutral-divider-inverted))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSDivider',
})

export default reactWrapper
